import * as React from 'react'
import { Col, DatePicker, Form, Input, Row, Switch } from 'antd'
import moment from 'moment'
import { useCallback, useEffect, useMemo, useRef } from 'react'
import { legalAgeValidator } from 'shared/utils/validators'
import { appointmentFormTitles, AppointmentFormValues } from './registration-form-fields'

interface AddMemberFormProps {
  formData?: any
  setFormData: (data: AppointmentFormValues) => void
  isValid?: (isValid: boolean) => void
}

function AddAppointmentForm({ formData, setFormData, isValid }: AddMemberFormProps) {
  const legalAge = 18
  const onFinish = (formData: AppointmentFormValues) => {
    setFormData(formData)
  }
  const [form] = Form.useForm()
  const formRef = useRef(null)

  const requiredFieldsList = useMemo(
    () => ['firstName', 'lastName', 'birthDate'],
    []
  )

  const validating = useCallback(() => {
    form
      .validateFields(requiredFieldsList)
      .then((d) => {
        if (isValid) {
          isValid(true)
        }
      })
      .catch((e) => {
        if (isValid) {
          if (e.errorFields.length === 0) {
            isValid(true)
          } else {
            isValid(false)
          }
        }
      })
  }, [form, isValid, requiredFieldsList])

  useEffect(() => {
    validating()
  }, [formData, validating])

  return (
    <Form
      layout="vertical"
      form={form}
      ref={formRef}
      onFinish={onFinish}
      initialValues={{
        ...formData,
        birthDate: formData?.birthDate ? moment.utc(formData?.birthDate) : null,
      }}
      onValuesChange={(changedValues: any, values: any) => {
        setFormData({
          ...values,
          ...changedValues,
        })
      }}
    >
      <Row gutter={50}>
        <Col sm={12} xs={24}>
          <Form.Item
            label={appointmentFormTitles.documentNumber}
            name="documentNumber"
          >
            <Input autoFocus />
          </Form.Item>
        </Col>
        <Col sm={12} xs={24}>
          <Form.Item
            label={appointmentFormTitles.nfcKey}
            name="nfcKey"
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={50}>
        <Col sm={12} xs={24}>
          <Form.Item
            label={appointmentFormTitles.email}
            name="email"
          >
            <Input />
          </Form.Item>
        </Col>

        <Col sm={12} xs={24}>
          <Form.Item
            label={appointmentFormTitles.birthDate}
            name="birthDate"
            rules={[
              {
                required: true,
                message: 'Enter your birth date please.',
              },
              legalAgeValidator(legalAge),
            ]}
          >
            <DatePicker format="DD.MM.YYYY" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={50}>
        <Col sm={12} xs={24}>
          <Form.Item
            label={appointmentFormTitles.firstName}
            name="firstName"
            rules={[
              {
                required: true,
                message: 'Please input your first Name!',
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label={appointmentFormTitles.lastName}
            name="lastName"
            rules={[
              {
                required: true,
                message: 'Please input your last name!',
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col sm={12} xs={24}>
          <Form.Item
            label={appointmentFormTitles.nationality}
            name="nationality"
          >
            <Input />
          </Form.Item>

          <Form.Item label="Default Discount" name="defaultDiscount">
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={50}>
        <Col sm={12} xs={24}>
          <Form.Item label={appointmentFormTitles.address} name="address">
            <Input />
          </Form.Item>
        </Col>
        <Col sm={12} xs={24}>
          <Form.Item label={appointmentFormTitles.referredBy} name="referredBy">
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={50}>
        <Col sm={12} xs={24}>
          <Form.Item label={appointmentFormTitles.isNoFee} name="isNoFee" valuePropName="checked">
            <Switch checkedChildren="No Membership Fee" unCheckedChildren="Should Pay" />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

export default AddAppointmentForm
